import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class StorybookRoute extends Route {
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel() {
		if (!this.currentUserService.hasDataboxEmail) {
			this.navigationService.transitionToRoute('index');
		}
	}
}
